import theme from '../../base';

const checkbox = {
  default: {
    bg: theme.colors.neutrals.white,
    border: theme.colors.neutrals.gray700,
    label: theme.colors.neutrals.gray700,
  },
  checked: {
    bg: theme.colors.blues.blue500,
    border: theme.colors.blues.blue500,
    icon: theme.colors.neutrals.white,
  },
  disabled: {
    bg: theme.colors.neutrals.gray250,
    border: theme.colors.neutrals.gray500,
    icon: theme.colors.neutrals.gray500,
  },
  error: {
    bg: theme.colors.reds.red100,
    border: theme.colors.reds.red900,
  },
  focus: {
    offsetShadow: theme.colors.blues.blue300,
    insetShadow: theme.colors.neutrals.white,
  },
  bulk: {
    symbol: theme.colors.neutrals.gray700,
  },
};

export default checkbox;
